document.addEventListener('DOMContentLoaded', () => {
  const blogSearchButton = document.getElementById('blog-search-button');
  const blogSearchInput = document.querySelector("input[name='q'][type='search']");

  if (blogSearchButton && blogSearchInput) {
    blogSearchButton.addEventListener('click', () => {
      const searchTerm = blogSearchInput.value.trim();

      if (searchTerm) {
        // Fire GA4 blog search event
        if (typeof gtag === 'function') {
          gtag('event', 'blog_search', {
            event_category: 'Blog',
            search_term: searchTerm
          });
        } 
      }
    });
  }
});
